/**
 * Created by Paul on 6/9/2017.
 */
import {Component, Input} from "@angular/core";

@Component({
  selector: 'sm-drop-down-panel',
  templateUrl: './sixMarkDropDownPanel.html',
  styleUrls: [ '/sixMarkDropDownPanel.scss' ]
})

export class SixMarkDropDownPanelComponent {
  _winOpenNumberList = [];

  // List of objects { issue: number, numbers: [] }
  resultNumbersList = [];

  // List of ball colors and its corresponding numbers
  ballColors = [
    {
      color: 'green',
      numbers: [ 5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43 , 44, 49 ]
    },
    {
      color: 'red',
      numbers: [ 1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46 ]
    },
    {
      color: 'blue',
      numbers: [ 3, 4, 9, 10, 14, 15 , 20, 25, 26, 31, 36, 37, 41, 42, 47, 48 ]
    }
  ];

  @Input()
  set winOpenNumberList(list: any[]) {
    if (list) {
      // clear previous result
      this.resultNumbersList.splice(0);

      // Parse list to array with issue and its numbers
      this.getResultNumbersList(list);
      this._winOpenNumberList = list;
    }
  }

  get winOpenNumberList() {
    return this._winOpenNumberList;
  }

  /**
   * Retrie issue and its numbers from open win number item
   * @param item: open win number item
   * @returns {{issue: string, numbers: Array}}
   */
  getResultNumbers(item) {
    let result = {
      issue: '',
      numbers: []
    };

    if (item) {
      // issue number
      result.issue = item.issue;

      let numbers = [];
      // winnumber exp: "12|43|21|9|2|10&7"
      // special number -> 7
      // numbers array 1->6 => 12, 43, 21, 9, 2, 10
      let types = item.winnumber.split('&');

      if (types.length === 2) {
        let specialNumber = Number.parseInt(types[1]);
        let normalNumbers = types[0].split('|');

        numbers.push(specialNumber);
        normalNumbers.forEach(number => {
          numbers.push(Number.parseInt(number));
        });

        result.numbers = numbers;
      }
    }

    return result;
  }

  /**
   * Retrieve issue and its numbers from open win number list to result list
   * @param list
   */
  getResultNumbersList(list = []) {
    list.forEach(item => {
      // parse item to get issue and list of numbers only
      let resultItem = this.getResultNumbers(item);
      if (resultItem) {
        this.resultNumbersList.push(resultItem);
      }
    });
  }

  /**
   * Get ball color based on input number
   * @param number: an integer in range of [1, 49]
   * @returns {string}: ball color class
   */
  getBallColorClass(number) {
    let n = this.ballColors.length;
    for (let i = 0; i < n; i++) {
      // Check if input number belongs to which color category
      if (this.ballColors[i].numbers.indexOf(number) >= 0) {
        return this.ballColors[i].color;
      }
    }
    return 'green';
  }
}



// WEBPACK FOOTER //
// ./src/component/sixMarkDropDownPanel/sixMarkDropDownPanel.ts